import { useEffect } from 'react';

import {
	useAvailableSitesState,
	useMappingsActions,
} from '../providers/BulkConfigureContextProvider';
import { useIssueCreateSidePanelContext } from '../providers/IssueCreateSidePanelContextProvider';
import { getJiraWorkItemKeysFromTable } from '../utils/tableUtils';

import { fetchBulkWorkItemTypes } from './apiUtils';
import { IssueType } from '../providers/BulkCreateContextProvider';
import { JiraIssueKeysToTypes } from '../__types__/apiUtils';

export const useGetMappedJiraWorkItemTypes = () => {
	const [{ selectedTable }] = useIssueCreateSidePanelContext();
	const { selectedAvailableSite } = useAvailableSitesState();
	const { setAvailableColumnWorkItemTypes } = useMappingsActions();

	useEffect(() => {
		const fetchWorkItemTypes = async () => {
			const cloudId = selectedAvailableSite?.cloudId;
			if (!selectedTable || !cloudId) {
				return;
			}

			const workItemKeysByColumn = getJiraWorkItemKeysFromTable(selectedTable);
			const results = new Map<number, JiraIssueKeysToTypes>();

			const fetchPromises = Array.from(workItemKeysByColumn.entries()).map(
				async ([columnIndex, workItemKeys]) => {
					if (workItemKeys.length > 0) {
						const mappedIssuesForColumn = await fetchBulkWorkItemTypes({ cloudId, workItemKeys });
						return {
							columnIndex,
							mappedIssuesForColumn: new Map<string, IssueType>(mappedIssuesForColumn ?? []),
						};
					}
					return null;
				},
			);

			const fetchResults = await Promise.all(fetchPromises);

			fetchResults.forEach((result) => {
				if (result && result.mappedIssuesForColumn.size > 0) {
					results.set(result.columnIndex, result.mappedIssuesForColumn);
				}
			});

			setAvailableColumnWorkItemTypes(results);
		};
		void fetchWorkItemTypes();
	}, [selectedTable, selectedAvailableSite?.cloudId, setAvailableColumnWorkItemTypes]);
};
